import { render, staticRenderFns } from "./_MediaGroupMediaWrapper.vue?vue&type=template&id=72fad5cb&scoped=true&"
import script from "./_MediaGroupMediaWrapper.vue?vue&type=script&lang=js&"
export * from "./_MediaGroupMediaWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fad5cb",
  null
  
)

export default component.exports